import React, {useState, useEffect} from 'react'
import { Loader } from '../Loader'
// img
import file from '../../assets/img/newPFOffer/file.svg'
import Resumen from '../../assets/img/Icono Resumen.svg'
import Cerrar from '../../assets/img/Cerrar.svg'
import rent from '../../assets/img/newPFOffer/rent.svg'
import vol from '../../assets/img/newPFOffer/vol.svg'
import rent2 from '../../assets/img/newPFOffer/rent2.svg'
import o from '../../assets/img/newPFOffer/o.svg'
import c from '../../assets/img/newPFOffer/c.svg'
// css
import '../../assets/css/newPFOffer/modelo.css'
import TableauReport from 'tableau-react'
import {config} from '../../config'

function getViewProduct(id_offer, code_product, customer, distributor_name = null) {
	const session_token = localStorage.getItem('session')
	//console.log(session_token);
	//if there is a session token stored
	if (session_token) {
		if (!distributor_name) {
			return fetch(config.apiUrlTradOferta + `/offer/product/`+code_product+`/`+id_offer, {
				//mode: 'no-cors',
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + session_token,
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Credentials': true,
				},
			})
				.then((response) => {
					//console.log(response.ok)
					return response.json()
				})
				.then((response) => {
					//console.log(response)
					return response
				})
		} else {
			return fetch(config.apiUrlTradOferta + `/offer/product/`+code_product+`/`+id_offer+`/`+distributor_name, {
				//mode: 'no-cors',
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + session_token,
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Credentials': true,
				},
			})
				.then((response) => {
					//console.log(response.ok)
					return response.json()
				})
				.then((response) => {
					//console.log(response)
					return response
				})
		}
	}

	//there are no session token stored
	return {}
}


export const ModeloPopup = ({setModeloPopupState, product, setProduct, cadena, id_oferta}) => {
	console.log("vista producto: ")
	console.log(product)
	console.log("cadena::: ")
	console.log(cadena)
	const [tokenTableau, setTokenTableau] = useState()
	const [loading, setLoading] = useState(true)
	const [productView, setProductView] = useState(null)

    //PF/Promo/AnlisisROI
	let url_ = 'https://tableauserver-azure.pricemaker.io/t/PF/views/'
	let complete_code = ''// product.product_rows[0].product_code
	let parameters_ = {}
	if (product.distributor_code != null) {
		//Cuando es un producto por una oficina.
		complete_code = product.product_code + '-' + product.distributor_code
		parameters_ = {
			'Id G': [complete_code], //dataProduct.code_product
		}
		url_ += 'basetest_trad/titi3'
	}else {
			//Cuando es un producto en general
			let array_str = "";
			complete_code = product.product_rows[0].product_code
			product.product_rows.forEach((element) => {
				array_str += element.distributor_code+'-'+element.distributor_name + ',';
			});
			array_str = array_str.slice(0, -1);
			parameters_ = {
				'codigo_producto': [complete_code], //dataProduct.code_product
				'Oficinas': [array_str],
			}
			url_ += 'basetest_trad2/dash'
	}

	const fetchApi = async (tradicional = false) => {
		let url = 'https://optimusprice.pricemaker.io/api/getChartTrust'
		//https://tableauserver-azure.pricemaker.io/t/Soprole/views/basetest/titi2
		let dtarget_site = 'PF'
		let project = 'basetest_trad'
		let page = 'titi3'
		const response = await fetch(url, {
			method: 'POST',
			body: JSON.stringify({
				token: window.sessionStorage.getItem('token') + '-2chzRY3F3I9@',
				tabs_permission: 2,
				dtarget_site: dtarget_site,
				project: project,
				page: page,
			}),
		})

		console.log(response.status)
		const responseJSON = await response.json()
		setTokenTableau(responseJSON.token_server)
	}

	

    useEffect(() => {
		fetchApi()
    }, [])

	useEffect(() => {
		if (product.product_rows && product.product_rows.length > 0 && product.product_rows[0].product_code) {
			getViewProduct(id_oferta, product.product_rows[0].product_code, cadena).then((response) => {
				console.log("response:::: list product view Carga General!! ::: ");
				console.log(response);
				setProductView(response);
				setLoading(false);
			});
		} else if (product.product_code) {
			getViewProduct(id_oferta, product.product_code, cadena, product.distributor_name).then((response) => {
				console.log("response:::: list product view Carga por Producto!! ::: ");
				console.log(response);
				setProductView(response);
				setLoading(false);
			});
		} else {
			console.error("No valid product code found!");
			setLoading(false);
		}
		
			

	}, [])

	return (
		<>
		{loading && <Loader message={"Cargando... "}/>}
		{!loading && <div className='popupWrapper OfertaWrapper TottusPop CodigoPop'
		>
			
			<div
				className='ModeloPopupbg'
				onClick={(e) => {
					setModeloPopupState(false)
					setProduct(null)
				}}
			></div>
			<div className='popup ModeloPopup'>
				<div
					className='close_icon '
					onClick={(e) => {
						setModeloPopupState(false)
						setProduct(null)
					}}
				>
					<img src={Cerrar} alt='' />
				</div>
				<div className='left_side'>
					<h1>
						<svg
							width='24'
							height='24'
							viewBox='0 0 24 24'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<mask
								id='mask0_2505_117424'
								maskUnits='userSpaceOnUse'
								x='0'
								y='0'
								width='24'
								height='24'
							>
								<rect width='24' height='24' fill='#D9D9D9' />
							</mask>
							<g mask='url(#mask0_2505_117424)'>
								<path
									d='M2 6H3.83299V19H2V6ZM7.45825 6H8.35438V19H7.45825V6ZM4.72912 6H6.56212V19H4.72912V6ZM19.2709 6H22V19H19.2709V6ZM10.1874 6H11.9796V19H10.1874V6ZM16.5418 6H17.4379V19H16.5418V6ZM12.9165 6H15.6456V19H12.9165V6Z'
									fill='#AEB0B0'
								/>
							</g>
						</svg>
												{
						product.product_rows && product.product_rows.length > 0 && product.product_rows[0].product_code 
							? product.product_rows[0].product_code 
							: product.product_code
						}
						<p className='special_p'>{product.product_description}</p>
					</h1>

					<table className='table1'>
						<tbody>
							<tr>
								<td>
									<p>Línea</p>
									<h1>{productView && productView.linea}</h1>
								</td>
								<td>
									<p>Familia</p>
									<h1>{productView && productView.familia}</h1>
								</td>
								<td>
									<p>Sub Familia</p>
									<h1>{productView && productView.subfamilia}</h1>
								</td>
								<td className='border-gray' width='12%'>
									<p>Marca</p>
									<h1>{product.product_rows && product.product_rows.length > 0 && product.product_rows[0].product_code  ? product.product_rows[0].short_brand : product.short_brand}</h1>
								</td>
								<td>
									<p>Peso Caja</p>
									<h1>{productView.peso_caja}</h1>
								</td>
								<td>
									<p>Peso Unidad</p>
									<h1>{productView.peso_unidad}</h1>
								</td>
								<td width='5%'>
									<p>Unidades</p>
									<h1>{productView.unidades}</h1>
								</td>
								<td>
									<p>Formato Venta</p>
									<h1>{productView.formato_venta}</h1>
								</td>
							</tr>
						</tbody>
					</table>

					<table className='table2'>
						<tbody>
							<tr>
								<td>
									<p>Cto. Direc.</p>
									<h1>{productView.costo_directo}</h1>
								</td>
								<td>
									<p>Cto. Proyec.</p>
									<h1>{productView.costo_proyeccion}</h1>
								</td>
								<td>
									<p>Ticket Vol. UMP</p>
									<h1>{productView.ticket_vol_ump}</h1>
								</td>
								<td>
									<p>Cartera</p>
									<h1>{productView.cartera}</h1>
								</td>
								<td>
									<p>Frec. Compra</p>
									<h1>{productView.frec_compra}</h1>
								</td>
								<td>
									<p>Crec. Interanual</p>
									<h1>{productView.crec_interanual}</h1>
								</td>
								<td>
									<p>Vta. Prom.</p>
									<h1>{productView.vta_prom}</h1>
								</td>
								<td>
									<p>Días Inventario</p>
									<h1>{productView.dias_inventario}</h1>
								</td>
							</tr>
						</tbody>
					</table>

					<h1 style={{marginTop: 24}}>
						<img src={Resumen} alt='' />
						Detalles Optimización
					</h1>

					<div className='table_grid'>
						<table>
							<tbody>
								<tr>
									{ /*
									<td>MAPE</td>
									<td>
										<p>-</p>
										<h1>-</h1>
									</td>
					*/ }
									<td className='border-gray' width='15%'>
										<p>Elast</p>
										<h1>{productView.elasticidad}%</h1>
									</td>
									{
										productView.mape_name.length > 0 &&
										productView.mape_name.map((name, index) => {
											return (
												<td key={index}>
													<p>{name}</p>
													<h1><b>{productView.mape_value[index]}</b></h1>
												</td>
											)
										})
									}
								</tr>
							</tbody>
						</table>
						<table>
							<tbody>
								<tr>
									<td>
										<p>Precio Opt.</p>
										<h1>{productView.precio_optimizado}</h1>
									</td>
									<td>
										<p>Vol. Opt.</p>
										<h1>{productView.volumen_optimizado}</h1>
									</td>
									<td>
										<p>Precio Act.</p>
										<h1>{productView.precio_actual}</h1>
									</td>
									<td>
										<p>Vol. Act.</p>
										<h1>{productView.volumen_actual}</h1>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className='table_grid table_grid2'>
						<table>
							<tbody>
								<tr>
									<td className='border-gray'>
										<div className='flex'>
											<img src={rent} alt='' />
											<p>
												Rent. <br /> + Vol.
											</p>
										</div>
									</td>
									<td>
										<p>Precio</p>
										<h1>{productView.prices.optimization.price}</h1>
									</td>
									<td>
										<p>Vol.</p>
										<h1>{productView.prices.optimization.vol}</h1>
									</td>
								</tr>
							</tbody>
						</table>
						<table>
							<tbody>
								<tr>
									<td className='border-gray'>
										<div className='flex'>
											<img src={vol} alt='' />
											<p>Vol.</p>
										</div>
									</td>
									<td>
										<p>Precio</p>
										<h1>{productView.prices.volume.price}</h1>
									</td>
									<td>
										<p>Vol.</p>
										<h1>{productView.prices.volume.vol}</h1>
									</td>
								</tr>
							</tbody>
						</table>
						<table>
							<tbody>
								<tr>
									<td className='border-gray'>
										<div className='flex'>
											<img src={rent2} alt='' />
											<p>Rent.</p>
										</div>
									</td>
									
									<td>
										<p>Precio</p>
										<h1>{productView.prices.profitability.price}</h1>
									</td>
									<td>
										<p>Vol.</p>
										<h1>{productView.prices.profitability.vol}</h1>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<h1 style={{marginTop: 24}}>
						<img src={file} alt='' />
						Activaciones
					</h1>
					<div className='activate-table-wrapper'>
						<table className='activate-table'>
							<thead>
								<tr>
									<th>Tipo</th>
									<th>Nombre</th>
									<th>Vigencia</th>
									<th>Oficinas</th>
									<th>Precio</th>
									<th>Vol.</th>
									<th>PVP</th>
									<th>RO</th>
								</tr>
							</thead>
							<tbody>
							{product.product_rows && product.product_rows.length > 0 && product.product_rows[0].product_code && product.product_rows.map(
								
								(row) => {
									let img_;
									if(row.type === "catalog") {
										img_ = c
									}else{
										img_ = o
									}
									return (<>
									<tr>
										<td>
											<img src={img_} alt='' />
										</td>
										<td>{row.promotion_name}</td>
										<td>
											{row.tooltip_sellin}
										</td>
										<td>
											{row.distributor_name}
										</td>

										<td>{row.strat_price}</td>
										<td>{row.curr_vol}.</td>
										<td>{row.recommended_pvp}</td>
										<td>{row.strat_ro_pct}</td>
									</tr>
									</>)
								}
							)}
							</tbody>
						</table>
					</div>
				</div>
				<div className='right_side' style={{overflow: 'auto'}}>
					
					<div className='gray_area' style={{ background: 'transparent' , overflow: "auto"}}>

					{!tokenTableau ? (
								'Cargando Dashboard...'
							) : (
								<TableauReport
									url={url_}
									token={tokenTableau}
									options={{
										width: 680,
										height: "100vh",
									}}
									parameters={parameters_}
									query="?:jsdebug=n"
								/>
							)}
					</div>
				</div>
			</div>
		</div>}
		</>
	)
}
